import * as Icons from "@nova/component-icons"
import { UploadComponentProps } from "@nova/constants"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { noop } from "nodash"
import { FC } from "react"
import { closeLayer } from "../thunks"
import { PluginActionsContext } from "../plugin-actions/usePluginActionsContext"
import { PluginSpec } from "plugins/plugin-registry"
import { setActiveFeatureId, setActiveLayerId } from "../slice.new"
import { SidePanelActiveFeaturePlugin } from "../useSidePanelActiveFeature"

export function getGenericUploadFlowActiveFeatureSidePanelComponent({
    MultifileUploadComponent,
}: {
    MultifileUploadComponent: FC<UploadComponentProps>
}) {
    const GenericUploadFlowActiveFeatureSidePanelComponent = ({ id }: { id?: string }) => {
        const dispatch = useAppDispatch()
        const workspaceId = useAppSelector(selectActiveWorkspaceId())
        const projectId = useAppSelector(selectActivatedFireId)
        if (!id || !workspaceId || !projectId) return null
        return (
            <div className="px-3 shrink min-h-0 flex flex-col">
                <MultifileUploadComponent
                    id={id}
                    blurData={() => dispatch(closeLayer())}
                    fireId={projectId}
                    portfolioId={workspaceId}
                    processedActionHandler={{
                        title: "Zoom To",
                        icon: () => <Icons.Center className="!h-[1.5em] !mb-0 scale-75" />,
                        handler: noop,
                    }}
                />
            </div>
        )
    }
    return GenericUploadFlowActiveFeatureSidePanelComponent
}

export function getGenericActiveFeatureSidePanelComponent({
    spec,
    RenderComponent,
}: {
    spec: PluginSpec
    RenderComponent: FC
}) {
    const GenericActiveFeatureSidePanelComponent = () => {
        return (
            <PluginActionsContext.Provider
                value={{
                    displayName: spec.actionsDisplayName || spec.displayName,
                    iconUrl: spec.ImageIconUrl,
                }}
            >
                <RenderComponent />
            </PluginActionsContext.Provider>
        )
    }
    return GenericActiveFeatureSidePanelComponent
}

export function getGenericMultistepUploadFlowActiveFeatureSidePanelComponent({
    InitialRenderComponent,
    UploadFlowRenderComponent,
}: {
    InitialRenderComponent: FC
    UploadFlowRenderComponent: FC<{ id?: string }>
}) {
    const GenericMultistepUploadFlowActiveFeatureSidePanelComponent = ({
        id,
        plugin,
    }: {
        id?: string
        plugin: SidePanelActiveFeaturePlugin
    }) => {
        const dispatch = useAppDispatch()
        const entity = useAppSelector(plugin.selectSingleEntity(id || ""))
        if (!id) return <InitialRenderComponent />
        if (!entity) {
            dispatch(setActiveLayerId({ id: undefined }))
            dispatch(setActiveFeatureId({ feature: undefined }))
            return null
        }
        return <UploadFlowRenderComponent id={id} />
    }
    return GenericMultistepUploadFlowActiveFeatureSidePanelComponent
}
